// import state from './moduleRoleState.js'
// import mutations from './moduleRoleMutations.js'
import actions from "./modulePermissionActions.js";
import getters from "./modulePermissionGetters.js";

export default {
	isRegistered: false,
	namespaced: true,
	state: {
		data: [],
		id_permission: null,
		rol_permission: [],
	},
	mutations: {
		ADD_ITEM(state, item) {
			state.data = item;
		},
		GET_ID_ROL(state, id_permission) {
			state.id_permission = id_permission;
		},
		RELATION_SHIP_ROL_PERMISSION(state, payload) {
			state.rol_permission = payload;
		},
	},
	actions,
	getters,
};
